import { Controller } from "@hotwired/stimulus"

import { pollFrame } from "../lib/poll_frame.mjs"

// Generic polling controller — refreshes the Turbo Frame it's attached to
export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 }, url: String, immediate: { type: Boolean, default: false } }

  connect() {
    if (this.immediateValue) this.poll()
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async poll() {
    pollFrame(this.element.closest("turbo-frame"), this.urlValue, document.baseURI)
  }
}
